import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import NavigationMenu from '../Menu/NavigationMenu.jsx';
import NavigationToggleButton from '../Toggle/Button/NavigationToggleButton.jsx';
import styles from '../Navigation.less';
import { getIsNavigationHeaderFolded } from '../../../selectors/selectors';
import { isFeatureOn } from '../../../utils/featureSwitchReader';
import NewNavigationHeader from '../Header/NewNavigationHeader';
import SavingAddressSearch from '../../AddressSearch/AddressSearch/SavingAddressSearch';
import { withLocation } from "../../../utils/router";

export class NavigationSidebarTablet extends React.Component {
  constructor(props) {
    super(props);
    this.container = React.createRef();

    this.bodyClickHandler = this.bodyClickHandler.bind(this);
  }

  componentDidMount() {
    document.body.addEventListener('click', this.bodyClickHandler);
  }

  componentWillUnmount() {
    document.body.removeEventListener('click', this.bodyClickHandler);
  }

  bodyClickHandler(event) {
    if (!this.props.isExpanded) {
      return;
    }

    const isClickedTargetInContainer = this.container.current.contains(event.target);

    if (!isClickedTargetInContainer) {
      this.props.onFocusOut();
    }
  }

  render() {
    const { isExpanded, isNavigationHeaderFolded } = this.props;

    return (
      <div className={`grid ${styles.nav_bar} border-right`} ref={this.container}>
        {isExpanded ? (
          <>
            <NavigationToggleButton />
            {
              <>
                <SavingAddressSearch className="padding-m" />
                <div className={`grid padding-m ${styles.nav_header} ${isNavigationHeaderFolded ? styles.folded : ''}`}>
                  <NewNavigationHeader />
                </div>
              </>
            }
            <NavigationMenu />
          </>
        ) : (
          <>
            <NavigationToggleButton />
            <NavigationMenu collapsed />
          </>
        )}
      </div>
    );
  }
}

NavigationSidebarTablet.defaultProps = {
  isExpanded: false,
  onFocusOut: () => {},
  subTitle: '',
  isFeatureOn,
};

NavigationSidebarTablet.propTypes = {
  title: PropTypes.string.isRequired,
  location: PropTypes.object.isRequired,
  isNavigationHeaderFolded: PropTypes.bool.isRequired,
  subTitle: PropTypes.string,
  onFocusOut: PropTypes.func,
  isExpanded: PropTypes.bool,
  isFeatureOn: PropTypes.func,
};

const mapStateToProps = (state) => ({
  isNavigationHeaderFolded: getIsNavigationHeaderFolded(state),
});

const ConnectedSidebar = connect(mapStateToProps)(NavigationSidebarTablet);

export default withLocation(ConnectedSidebar);
